import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  onChangeTab(event) {
    let queryParams = new URLSearchParams(window.location.search);
    queryParams.set('tab', event.params.tab);
    history.replaceState(null, null, '?' + queryParams.toString());
  }
}
